import React from 'react'
import { getBEMCls } from '@/utils/classname'
import { Row } from '@/components/layout/layout'
import Iconfont from '@/components/iconfont/iconfont'
import { Switch, Spin, Popover } from 'antd'
import $msg from '@/utils/message'
import { $post } from '@/api'
import { useRequest } from 'ahooks'
import { goodsShelfStore } from '../../store/goods-shelf'
import { observer } from 'mobx-react'
import { showLayer } from '@/utils/layer'
import MallGoodsSort from '../../component/sort-good/sort-good'

const ShelfConfig = observer((props: { onClose: () => void }) => {
    const getCls = (e?: string, m?: string) => getBEMCls('goods-shelf', e, m)

    const getConfig = useRequest(
        () =>
            $post({
                url: '/mall/getshelfconfig',
            }),
        {
            onSuccess: res => {
                goodsShelfStore.setShelfConfig(res)
            },
            manual: !!goodsShelfStore.mallShelfConfig, // 如果在商品库已经请求过，则忽略第一次请求
        },
    )

    const updateShelfConfigData = useRequest(
        (key: 'independent_shelf' | 'hot_sold') =>
            $post({
                url: '/mall/editmallconfig',
                params: {
                    [key]: goodsShelfStore.mallShelfConfig && !goodsShelfStore.mallShelfConfig[key],
                },
            }),
        {
            onSuccess: () => {
                $msg('success', '更新成功')
                getConfig.run()
                goodsShelfStore.setUpdateGroup()
                goodsShelfStore.resetGoodTableData()
            },
            onError: e => {
                $msg('error', e.message)
            },
            manual: true,
        },
    )

    const shelfConfigData: {
        uid: number
        key: 'hot_sold' | 'independent_shelf'
        text: string
        tip: string
        onClick: () => void
    }[] = [
        {
            uid: 1,
            key: 'hot_sold',
            text: '近期热卖',
            tip: '开启后微商城将自动展示最近一周销量前八的商品',
            onClick: () => {
                updateShelfConfigData.run('hot_sold')
            },
        },
        {
            uid: 2,
            key: 'independent_shelf',
            text: '最新上架',
            tip: '开启后所有商品库中新上架的商品都默认展示在此分组',
            onClick: () => {
                $msg(
                    'error',
                    goodsShelfStore.mallShelfConfig?.independent_shelf
                        ? '独立货架开启状态下，不能关闭最新分组'
                        : '开启独立货架后才能开启最新分组',
                )
            },
        },
        {
            uid: 3,
            key: 'independent_shelf',
            text: '独立货架',
            tip: '开启后可在货架中单独管理商城商品的上下架',
            onClick: () => {
                updateShelfConfigData.run('independent_shelf')
            },
        },
    ]

    return (
        <Spin spinning={getConfig.loading}>
            <ul data-padding-v-10>
                {shelfConfigData.map(config => (
                    <li key={config.uid} className={getCls('popover', 'item')}>
                        <Row data-align-items-center>
                            {config.text}
                            <Popover placement="top" trigger="click" title={config.tip}>
                                <Iconfont
                                    name="icon8yiwen-16"
                                    size={16}
                                    style={{
                                        marginLeft: '4px',
                                    }}
                                />
                            </Popover>
                        </Row>
                        <span data-margin-left-10>
                            <Switch
                                checked={
                                    !!goodsShelfStore.mallShelfConfig && goodsShelfStore.mallShelfConfig[config.key]
                                }
                                onClick={() => {
                                    config.onClick()
                                }}
                            ></Switch>
                        </span>
                    </li>
                ))}
                {!!goodsShelfStore.mallShelfConfig?.independent_shelf && (
                    <li
                        className={getCls('popover', 'sort')}
                        onClick={() => {
                            if (!goodsShelfStore.mallShelfConfig) return
                            props.onClose()
                            showLayer(<MallGoodsSort />)
                        }}
                    >
                        商品排序
                    </li>
                )}
            </ul>
        </Spin>
    )
})

export default ShelfConfig
